import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  useEffect,
} from "react";
import Config from "./config";

import Login from "./components/login";
import Home from "./components/home";
import Dashboard from "./components/home/views/dashboard";
import Calendar from "./components/home/views/calendar";
import SalesComponent from "./components/home/views/sales";
// import Sales from "./components/home/views/sales";
import Audit from "./components/home/views/audit";
import PDFReports from "./components/home/views/reports";
import MenuReports from "./components/home/views/menuReports";
import MenuEngineering from "./components/home/views/menuEngineering";
import Account from "./components/home/views/account";
import Group from "./components/home/views/group";
import User from "./components/home/views/user";
import ErrorPage from "./components/settings/error";
import Loader from "./components/settings/loader";
import View1 from "./components/home/elements/view1";
import Body from "./components/home/elements/body";
import Analytics from "./components/home/views/analytics";
import Settings from "./components/home/views/settings";

import ProtectedRoute from "./Wrapper";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [filterValue, setFilterValue] = useState(null);
  const [toggle, setToggle] = useState(false);
  const [user, setUser] = useState({ state: false, data: null });
  const routes = useMemo(() => [
    { name: "Home", path: "/app/*", element: <Home /> },
    { name: "Login", path: "/login/*", element: <Login /> },
    // { name: "Body", path: "/app/*", element: <Body /> },
  ]);
  const [preservedAuditData, setPreservedAuditData] = useState(null);
  const [preservedSalesData, setPreservedSalesData] = useState(null);
  const [preservedSessionData, setPreservedSessionData] = useState(null);

  const components = useMemo(
    () => ({
      page: [
        { name: "Dashboard", path: "dashboard", element: <Dashboard /> },
        { name: "Calendar", path: "calendar", element: <Calendar /> },
        { name: "Sales", path: "sales/*", element: <SalesComponent /> },
        { name: "Audit", path: "audit/*", element: <Audit /> },
        { name: "Reports", path: "menuReports/*", element: <MenuReports /> },
        {
          name: "Menu Engineering",
          path: "menuEngineering/*",
          element: <MenuEngineering />,
        },
        { name: "Account", path: "account/*", element: <Account /> },
        { name: "PDF Reports", path: "reports", element: <PDFReports /> },
        { name: "Group", path: "group/*", element: <Group />, auth: true },
        { name: "User", path: "user/*", element: <User />, auth: true },
        { name: "Analytics", path: "analytics/*", element: <Analytics /> },
        {
          name: "View",
          path: "view/:type/:id",
          element: <View1 />,
          auth: true,
        },
        { name: "Settings", path: "settings/*", element: <Settings /> },
      ],
      setting: [
        { name: "Error", component: ErrorPage },
        { name: "Loader", component: Loader },
      ],
    }),
    []
  );

  const chimeraserv = useMemo(() => ({
    urlGet: Config.get,
    urlPost: Config.post,
  }));

  const appContextValue = {
    routes,
    components,
    chimeraserv,
    user,
    setUser,
    toggle,
    setToggle,
    ProtectedRoute,
    filterValue,
    setFilterValue,
    preservedAuditData,
    setPreservedAuditData,
    preservedSalesData,
    setPreservedSalesData,
    preservedSessionData,
    setPreservedSessionData,
  };
  return (
    <AppContext.Provider value={appContextValue}>
      {children}
    </AppContext.Provider>
  );
};

// Custom Hook for easy access
export const useAppContext = () => useContext(AppContext);
